import { useCallback } from 'react';

import { LayerNames, LayerVisibilityMode } from '@/modules/common/types/layers';
import { useUpdateUserPreferences } from '@modules/userPreferences/hooks';

import { getLayerDefinition, getLayerVisibilityModePreference } from '../layerTree';

const normalizeVisibilityMode = (
  layerName: LayerNames,
  mode: LayerVisibilityMode,
): LayerVisibilityMode => {
  if (mode !== 'auto') return mode;

  const definition = getLayerDefinition(layerName);
  if (definition?.lod) return 'auto';

  return 'force_show';
};

export const useUpdateLayerUserPreference = () => {
  const { updateUserPreference } = useUpdateUserPreferences();

  const updateVisibilityMode = useCallback(
    (layerName: LayerNames, mode: LayerVisibilityMode) => {
      const preference = getLayerVisibilityModePreference(layerName);
      if (!preference) return;

      const visibilityMode = normalizeVisibilityMode(layerName, mode);

      updateUserPreference(preference, visibilityMode);
    },
    [updateUserPreference],
  );

  const updateVisibilityModes = useCallback(
    (layerNames: readonly LayerNames[], mode: LayerVisibilityMode) => {
      layerNames.forEach((layerName) => {
        const preference = getLayerVisibilityModePreference(layerName);
        if (!preference) return;

        const visibilityMode = normalizeVisibilityMode(layerName, mode);

        updateUserPreference(preference, visibilityMode);
      });
    },
    [updateUserPreference],
  );

  return {
    updateVisibilityMode,
    updateVisibilityModes,
  };
};
